import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { updateVendorContact } from '../api/client';

export default function ChangeContactPage() {
  const { auth, logout } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [contactName, setContactName] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  if (!auth && !success) {
    window.location.replace('/login');
    return null;
  }

  const handleSubmit = async () => {
    if (!email || !contactName) {
      setError('メールアドレスとお名前は必須です');
      return;
    }
    if (!window.confirm(`担当者を「${contactName}（${email}）」に変更します。\n変更後は、今のメールアドレスではログインできなくなります。よろしいですか？`)) return;
    setSubmitting(true);
    setError('');
    try {
      await updateVendorContact(auth!.vendorCompanyCode, { email, contactName });
      // v0.15: メールアドレスが変わるので、このログイン状態はここで終える（新担当者は新しいメアドでログイン）
      logout();
      setSuccess(true);
    } catch (e: any) {
      setError(e.response?.data?.message ?? 'エラーが発生しました');
    } finally {
      setSubmitting(false);
    }
  };

  if (success) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <h2 style={{ color: '#276749' }}>担当者情報を更新しました</h2>
          <p style={{ color: '#718096', lineHeight: 1.7 }}>
            新しい担当者のメールアドレス宛に、今後のご案内をお送りします。<br />
            以後は新しいメールアドレスでログインしてください。
          </p>
          <button style={styles.button} onClick={() => navigate('/login')}>
            ログイン画面へ
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <h1 style={styles.title}>担当者変更</h1>
          <button style={styles.logoutBtn} onClick={logout}>ログアウト</button>
        </div>
        <p style={styles.info}>{auth?.email} でログイン中</p>

        <p style={styles.note}>
          新しい担当者の情報を入力してください。<br />
          会社情報（口座・インボイス等）はそのまま引き継がれます。
        </p>

        <div style={{ marginBottom: 12 }}>
          <label style={styles.label}>新しい担当者のメールアドレス *</label>
          <input
            style={styles.input}
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="new-contact@company.com"
          />
        </div>

        <div style={{ marginBottom: 12 }}>
          <label style={styles.label}>新しい担当者のお名前 *</label>
          <input
            style={styles.input}
            value={contactName}
            onChange={e => setContactName(e.target.value)}
            placeholder="山田 太郎"
          />
        </div>

        {error && <p style={styles.error}>{error}</p>}
        <button style={styles.button} onClick={handleSubmit} disabled={submitting}>
          {submitting ? '更新中...' : '担当者を変更する'}
        </button>

        <button style={styles.backBtn} onClick={() => navigate('/invoice')}>
          請求書登録に戻る
        </button>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: { minHeight: '100vh', background: '#f0f4f8', padding: '24px 16px' },
  card: { background: '#fff', borderRadius: 12, padding: 28, maxWidth: 480, margin: '0 auto', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' },
  title: { margin: 0, fontSize: 20, color: '#1a365d' },
  info: { background: '#ebf8ff', borderRadius: 6, padding: '8px 12px', fontSize: 13, color: '#2c5282', marginBottom: 16 },
  note: { background: '#fffff0', border: '1px solid #fefcbf', borderRadius: 6, padding: 12, fontSize: 13, color: '#744210', lineHeight: 1.7, marginBottom: 16 },
  label: { display: 'block', fontWeight: 600, marginBottom: 4, fontSize: 13, color: '#4a5568' },
  input: { width: '100%', padding: '8px 10px', border: '1px solid #cbd5e0', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' as const },
  button: { width: '100%', padding: 14, background: '#2b6cb0', color: '#fff', border: 'none', borderRadius: 6, fontSize: 16, cursor: 'pointer', fontWeight: 600, marginTop: 8 },
  logoutBtn: { padding: '6px 14px', background: '#fff', color: '#718096', border: '1px solid #cbd5e0', borderRadius: 6, fontSize: 13, cursor: 'pointer' },
  error: { color: '#e53e3e', fontSize: 14, marginTop: 8 },
  backBtn: { width: '100%', marginTop: 10, padding: 10, background: 'none', color: '#718096', border: '1px solid #cbd5e0', borderRadius: 6, fontSize: 14, cursor: 'pointer' },
};
